/**
 * Created by Ning Jiang on 5/8/2018.
 */

import { IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import { FontWeight, FontType, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class FontConfig {

    public static FONTS:IFontsConfig = {
        OpenSans_Regular : {
            fontFamily : "Open Sans",
            src : [
                {url : "fonts/opensans/OpenSans-Regular-webfont.woff", format : FontType.WOFF},
                {url : "fonts/opensans/OpenSans-Regular-webfont.ttf", format : FontType.TTF}
            ],
            fontWeight : FontWeight.NORMAL,
            fontStyle : FontStyle.NORMAL
        },
        OpenSans_Light : {
            fontFamily : "Open Sans",
            src : [
                {url : "fonts/opensans/OpenSans-Light-webfont.woff", format : FontType.WOFF},
                {url : "fonts/opensans/OpenSans-Light-webfont.ttf", format : FontType.TTF}
            ],
            fontWeight : FontWeight.LIGHT,
            fontStyle : FontStyle.NORMAL
        },
        OpenSans_Bold : {
            fontFamily : "Open Sans",
            src : [
                {url : "fonts/opensans/OpenSans-Bold-webfont.woff", format : FontType.WOFF},
                {url : "fonts/opensans/OpenSans-Bold-webfont.ttf", format : FontType.TTF}
            ],
            fontWeight : FontWeight.BOLD,
            fontStyle : FontStyle.NORMAL
        },
        OpenSans_ExtraBoldItalic : {
            fontFamily : "Open Sans",
            src : [
                {url : "fonts/opensans/OpenSans-ExtraBoldItalic-webfont.woff", format : FontType.WOFF},
                {url : "fonts/opensans/OpenSans-ExtraBoldItalic-webfont.ttf", format : FontType.TTF}
            ],
            fontWeight : FontWeight.EXTRA_BOLD,
            fontStyle : FontStyle.ITALIC
        }
    };
}